export default __webpack_public_path__ + "static/media/question-mark-circle.30058894.svg";